// extracted by mini-css-extract-plugin
export default {"container":"ResumeContent_container__0HwZI"};